import "./index.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _component = require("../_utils/component");

var _Popover = _interopRequireDefault(require("../Popover"));

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('tooltip'),
  components: {
    Popover: _Popover.default
  },
  mixins: [_component.componentMixin],
  props: {
    /**
     * 距离目标的偏移量 详情见 [popper.js](https://popper.js.org/popper-documentation.html#modifiers..offset)
     */
    offset: {
      type: [String, Number],
      default: 0
    },
    tag: {
      type: [String, Object],
      default: 'span'
    },
    // 动画效果
    animation: {
      type: [Object, String],
      default: 'gd-fade'
    },
    // 默认是否显隐
    defaultVisible: {
      type: Boolean,
      default: false
    },
    // 延迟多久展示
    delayOnMouseOut: {
      type: Number,
      default: 50
    },
    delayOnMouseOver: {
      type: Number,
      default: 50
    },
    // 提示内容, 复杂结构考虑使用 slot
    content: {
      type: String
    },
    // 用于手动控制浮层显隐, 可用通过 visible.sync 和 trigger 一起生效
    visible: {
      type: Boolean,
      // -
      default: undefined
    },
    // 激活 tooltip 方式, 如果设置为 null 表示完全由 visible 控制
    trigger: {
      // 'hover', 'click', null
      type: String,
      default: 'hover',
      validator: function validator(value) {
        return ['click', 'hover'].indexOf(value) > -1;
      }
    },

    /**
     * 提示方向
     */
    placement: {
      // 'top-start' 'top' 'top-end' 'left-start' 'left' 'left-end' 'bottom-start' 'bottom' 'bottom-end'
      type: String,
      default: 'bottom'
    },
    // 主题色
    theme: {
      // 'dark' / ‘light’
      type: String,
      default: 'dark'
    },
    // 浮层自定义clas
    popoverClass: {
      type: String
    },
    // 提示元素参考的边界元素，详情见 [popper.js](https://popper.js.org/popper-documentation.html#modifiers..preventOverflow.boundariesElement)，默认是父级第一个可滚动元素
    boundariesElement: {
      type: [String, Object],
      default: 'scrollParent'
    }
  },
  computed: {
    modifiers() {
      return {
        offset: {
          offset: this.offset
        },
        preventOverflow: {
          boundariesElement: this.boundariesElement,
          padding: 0
        }
      };
    }

  },
  methods: {
    onClick(e) {
      /**
       * 浮层点击事件
       */
      this.$emit('click', e);
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("Popover", {
    attrs: {
      tag: _vm.tag,
      "popover-class": [_vm.popoverClass, _vm.bem()],
      placement: _vm.placement,
      delayOnMouseOut: _vm.delayOnMouseOut,
      delayOnMouseOver: _vm.delayOnMouseOver,
      theme: _vm.theme,
      animation: _vm.animation,
      defaultVisible: _vm.defaultVisible,
      visible: _vm.visible,
      trigger: _vm.trigger,
      modifiers: _vm.modifiers
    },
    on: {
      "update:visible": function updateVisible(v) {
        return _vm.$emit("update:visible", v);
      }
    }
  }, [_vm._t("default"), _vm._v(" "), _c("template", {
    slot: "content"
  }, [_c("div", {
    class: _vm.bem("content"),
    on: {
      click: _vm.onClick
    }
  }, [_vm._t("content", [_vm._v(_vm._s(_vm.content))])], 2)])], 2);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;